export default __webpack_public_path__ + "static/media/sounds/what_word_fills_in_the_blank.mp3";